// extracted by mini-css-extract-plugin
export var borderRadius = "_5g-4";
export var large = "_5g-3";
export var logoContainer = "_5g-0";
export var nameLogo = "_5g-2";
export var small = "_5g-1";